// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"9a32654a","221":"a73b3274","395":"e4c0e062","407":"d0efa4dd","485":"762566c9","598":"7b336a74","626":"3731df7e","791":"1ed307df","800":"ffc6d71a","831":"1bb2d9f0","942":"4d892c62"}[chunkId] + ".chunk.js";
};